import * as React from "react";
const SvgFiRrHandBill = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-hand-bill_svg__a)">
      <path
        fill="#062147"
        d="M16 9.5a1.5 1.5 0 1 1-3.001-.001A1.5 1.5 0 0 1 16 9.5M14.5 13a1.5 1.5 0 1 0 .001 3.001A1.5 1.5 0 0 0 14.5 13m8.5 5h-9a2.994 2.994 0 0 1-2.977-2.773l.212-.231a3 3 0 0 0-.232-4.231L11 10.763V9.001c0-1.654 1.346-3 3-3h9a1 1 0 0 0 0-2h-9c-1.627 0-3.061.793-3.974 2H6.173a7 7 0 0 0-4.481 1.623L.361 8.733a1 1 0 0 0 1.281 1.536L2.973 9.16a5 5 0 0 1 3.201-1.159h2.929a5 5 0 0 0-.101 1v1.015a3.1 3.1 0 0 0-1.972.731l-2.721 2.616a1 1 0 1 0 1.386 1.442l2.671-2.57a1 1 0 0 1 1.305.021.995.995 0 0 1 .086 1.397l-2.813 3.058A4 4 0 0 1 4 18.003H1a1 1 0 0 0 0 2h2.998a6.02 6.02 0 0 0 4.416-1.938l.998-1.085A5 5 0 0 0 14 20.002h9a1 1 0 0 0 0-2zm-1-8c.208 0 .426.042.667.126a.999.999 0 1 0 .667-1.885c-2.753-.976-5.333 1.114-5.333 3.759 0 2.206 1.794 4 4 4 .439 0 .876-.079 1.333-.241a1 1 0 0 0-.667-1.885c-.24.085-.458.126-.667.126-1.103 0-2-.897-2-2s.897-2 2-2"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-hand-bill_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrHandBill;
